module.exports = __webpack_public_path__ + "static/img/mingf17.af0e03cc.png";